<div *ngIf="isAdmin" class="card mt-1">
    <div class="card-header text-center d-flex align-items-center">
        <h3 class="flex-fill" paflabel="Contacts"></h3>
        <button class="btn btn-sm btn-success mx-1" type="button" (click)="excelExport.save()"
            [disabled]="LstContacts.length==0"><i class="far fa-file-excel mr-1"></i>Exporter</button>
    </div>
    <div class="card-body small">
        <kendo-grid 
            #grid
            class="lst-contacts-grid-results"
            [data]="gridDatas" 
            [pageSize]="state.take" 
            [skip]="state.skip" 
            [sort]="state.sort"
            [sortable]="true" 
            [pageable]="pagerSettings" 
            [height]="500"        
            [filterable]="'menu'"
            [filter]="state.filter" 
            (sortChange)="sortChange($event)"
            (pageChange)="pageChange($event)"
            (dataStateChange)="dataStateChange($event)" 
            [selectable]="selectableSettings"
            [resizable]="true">
            <kendo-grid-column field="SupplierName" [sortable]="true" title="Fournisseur"  [width]="350">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-column="column">
                    <a class="control-label" [routerLink]="getSupplierLink(dataItem)" [paftooltip]="'Fiche_fournisseur'" target="_blank">
                    {{ dataItem.SupplierName }}
                    </a>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Lastname" title="Nom"  [sortable]="true"  [width]="200"></kendo-grid-column>
            <kendo-grid-column field="Firstname" title="Prénom"  [sortable]="true"  [width]="200"></kendo-grid-column>
            <kendo-grid-column field="Fonction" title="Fonction"  [sortable]="true"  [width]="200"></kendo-grid-column>
            <kendo-grid-column field="Email" title="Email" [sortable]="true"  [width]="200"></kendo-grid-column>
            <kendo-grid-column field="Phone" title="Téléphone" [sortable]="true"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="CellPhone" title="Mobile" [sortable]="true"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column  [width]="150" field="canAccessPortail" title="Accès portail" filter="boolean">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div style="text-align: center;"><i [ngClass]="checkNgClass(dataItem.canAccessPortail)"></i></div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Statut" title="Statut"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="SupplierStatutLib" title="Statut du fournisseur"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="NumTiers" title="Tiers"  [autoSize]="true">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-column="column">
                    <div style="text-align: right; width:100%;">
                    <a class="control-label"  [routerLink]="getSupplierLink(dataItem)" [paftooltip]="'Fiche_fournisseur'" target="_blank">
                    {{ dataItem.NumTiers }}
                    </a></div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="UniqueId" title="N° identification"  [autoSize]="true"></kendo-grid-column>
        </kendo-grid>
            <kendo-excelexport [fileName]="excelFilename" [data]="LstContacts" [filterable]="true" #excelExport>
                <kendo-excelexport-column field="SupplierName" title="Fournisseur"></kendo-excelexport-column>
                <kendo-excelexport-column field="Lastname" title="Nom"></kendo-excelexport-column>
                <kendo-excelexport-column field="Firstname" title="Prénom"></kendo-excelexport-column>
                <kendo-excelexport-column field="Fonction" title="Fonction"></kendo-excelexport-column>
                <kendo-excelexport-column field="Email" title="Email"></kendo-excelexport-column>
                <kendo-excelexport-column field="Phone" title="Téléphone"></kendo-excelexport-column>
                <kendo-excelexport-column field="CellPhone" title="Mobile"></kendo-excelexport-column>
                <kendo-excelexport-column field="canAccessPortail" title="Accès portail"></kendo-excelexport-column>
                <kendo-excelexport-column field="Statut" title="Statut"></kendo-excelexport-column>
                <kendo-excelexport-column field="SupplierStatutLib" title="Statut du fournisseur"></kendo-excelexport-column>
                <kendo-excelexport-column field="NumTiers" title="Tiers"></kendo-excelexport-column>
                <kendo-excelexport-column field="UniqueId" title="N° identification"></kendo-excelexport-column>
            </kendo-excelexport>
    </div>
</div>